import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";
import ASSETS from "@/lib/assets";
import FloatingDecor from "@/components/motion/FloatingDecor";

export const PortraitWithBlob = ({
  size = "max-w-md",
  testId = "portrait-blob",
}) => {
  const reduced = usePreferStaticUI();

  return (
    <FloatingDecor range={reduced ? 0 : 8} duration={7} ariaHidden={false}>
      <div
        className={`relative ${size} w-full aspect-square mx-auto`}
        data-testid={testId}
      >
        <motion.div
          aria-hidden="true"
          className="absolute inset-0 rounded-[2.5rem] bg-gradient-to-br from-roseMilk/80 via-lavenderFog/40 to-sageMint/50"
          animate={reduced ? undefined : { opacity: [0.7, 1, 0.75] }}
          transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }}
        />
        {!reduced && (
          <motion.div
            aria-hidden="true"
            className="absolute inset-[-4%] rounded-[2.75rem] border border-raspberry/20"
            animate={{ opacity: [0.3, 0.7, 0.35] }}
            transition={{ duration: 4, repeat: Infinity, ease: "easeInOut" }}
          />
        )}
        <div className="absolute inset-[5%] rounded-[2rem] wit-glass-strong overflow-hidden shadow-lift">
          <img
            src={ASSETS.portrait}
            alt="Fatma Acar"
            className="w-full h-full object-cover"
            loading="eager"
            fetchPriority="high"
          />
        </div>
      </div>
    </FloatingDecor>
  );
};

export default PortraitWithBlob;
